import { useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
  isCredentialWebClockSession,
  WEBCLOCK_PATH,
} from '../utils/webClockSession';
import { useWebClockLogout } from './useWebClockLogout';

/**
 * Completes a successful punch once.
 * Credential sessions sign out to the login form. URL jwt launches return
 * to the clock.
 *
 * @returns {{ finish: () => void | Promise<void>, shouldSignOut: boolean }}
 */
export const useSuccessfulPunchCompletion = () => {
  const history = useHistory();
  const logout = useWebClockLogout();
  const hasFinishedRef = useRef(false);
  const shouldSignOut = isCredentialWebClockSession();

  const finish = useCallback(() => {
    if (hasFinishedRef.current) {
      return undefined;
    }
    hasFinishedRef.current = true;

    if (shouldSignOut) {
      return logout();
    }

    history.push(WEBCLOCK_PATH);
    return undefined;
  }, [shouldSignOut, logout, history]);

  return { finish, shouldSignOut };
};
